export class LoginFailedError {
  constructor(public readonly message: string) {}
}
